import React from 'react'
import ShippingService from '../services/shipping';
import $ from 'jquery';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import AuthorizationCheck from '../auth/authorizationCheck';
import NumberFormat from 'react-number-format';
import printJS from 'print-js';
import SupplierService from '../services/supplier';
import Utility from '../utilities/utility';
import PaymentService from '../services/payment';
import CountryService from '../services/country';
import Shipment from './shipment';
import ProductService from '../services/product';
import BranchService from '../services/branch';



class Shipments extends React.Component {

    constructor(props) {
        super(props);
        this.shippingService = new ShippingService();
        this.paymentService = new PaymentService();
        this.countryService = new CountryService();
        this.branchService = new BranchService();


        this.state = {
            shipments: [],
            suppliers: [],
            products: [],
            shipmentTotal: 0,
            shipmentFees: [],
            totalcbm: [],
            totalweight: [],
            showModal: false,
            showPayment: false,
            currentUserRole: '',
            countries: [],
            selectedShipment: '',
            showCreateShipment: false,
            confirmUnloading: false,
            unloadShipmentId: null,
            showRemoveConfirmationBox: false,
            showConfirmShipment: false
        }
    }

    shipments = () => {

        let description = $('#description').val();
        let containerId = $('#containerId').val();
        let countryId = $('#countryId').val();
        let shipmentUniqueId = $('#shipmentUniqueId').val();

        

        const response = this.shippingService.shipmentList(description, containerId, countryId, shipmentUniqueId);

        response.then(json => json.json())
            .then(data => this.setState({ shipments: data }))
            .catch(error => console.log(error));
    }

    componentDidMount() {

        try {

            const countryRequest = this.countryService.fetchCountries();


            const supplierRequest = SupplierService.supplierList();
            const shipmentsRequest = this.shippingService.shipmentList();


            Promise.all([supplierRequest, countryRequest, shipmentsRequest])
                .then((responseData) => {




                    if (!Utility.isEmpty(responseData[0])) {


                        responseData[0].json().then(response => {


                            this.setState({ suppliers: response });

                        })
                    }

                    if (!Utility.isEmpty(responseData[1])) {


                        responseData[1].json().then(response => {


                            this.setState({ countries: response });

                        })
                    }

                    if (!Utility.isEmpty(responseData[2])) {


                        responseData[2].json().then(response => {


                            this.setState({ shipments: response });

                        })
                    }






                });


        } catch (error) {

            console.log(error);
        }

        /*this.shipments();
        this.suppliers();
        this.countries();*/

        this.hidePrintData();
    }

    selectShipment(shipmentId) {

        localStorage.setItem('selectedShipment', shipmentId);
        window.location.href = '/admin/orders'

    }

    hidePrintData() {

        $('#print-data').hide();
    }



    updateShipment = (shipmentId, fieldName, fieldValue) => {



        let data = {
            'shipmentId': shipmentId
        };

        let updateField = '';

        if (fieldName == 'description') {


            updateField = 'shipment-desc-' + shipmentId;
            data.description = fieldValue;
        } else if (fieldName == 'containerId') {

            updateField = 'container-' + shipmentId;
            data.containerId = fieldValue;
        }

        const response = this.shippingService.updateShipment(data);
        response.then(res => res.json())
            .then(shipment => {

                this.updateShipmentField(shipment, fieldName, updateField);



            }).catch(console.log('error'));

    }

    updateShipmentField(shipment, fieldName, updateField) {

        if (fieldName == 'description') {

            $('.' + updateField).html(shipment.description);
        } else {

            $('.' + updateField).html(shipment.containerId);
        }
    }

    confirmUnload = (shipmentId, e) => {

        e.preventDefault();


        this.setState({

            confirmUnloading: true,
            unloadShipmentId: shipmentId
        });

    }

    hideUnloadingForm = () => {


        this.setState({

            confirmUnloading: false,

        })
    }

    setUnloaded = async () => {

        let shipmentId = this.state.unloadShipmentId;

        const response = await this.shippingService.setShipmentUnloaded(shipmentId);

        if (response.ok) {


            let shipments = this.state.shipments;

            let shipmentList = [];
            shipments.forEach(shipment => {

                if (shipment.shipmentId == shipmentId) {

                    shipment.unloaded = true;
                }

                shipmentList.push(shipment);
            });

            this.setState({

                shipments: shipmentList,
                confirmUnloading: false
            });


        }



    }

    findShipmentProducts = () => {



        let shipmentId = this.state.selectedShipment;

        let searchTerm = $('#shipment-search-key').val();
        let supplierUniqueId = $('#search-cpid').val();

        const response = this.shippingService.shipmentProducts(shipmentId, searchTerm, supplierUniqueId);

        response.then(jsonData => jsonData.json())
            .then(shipmentData => {


                this.setState({

                    products: shipmentData.shipmentProducts

                });
            })
            .catch(error => console.log(error))
    }

    showShipmentProducts = (shipmentId, e) => {

        e.preventDefault();

        this.setState({

            selectedShipment: null
        })


        let searchTerm = $('#shipment-search-key').val();

        const response = this.shippingService.shipmentProducts(shipmentId, searchTerm);

        response.then(jsonData => jsonData.json())
            .then(shipmentData => {


                this.setState({
                    products: shipmentData.shipmentProducts,
                    shipmentTotal: shipmentData.total,
                    shipmentFees: shipmentData.shipmentFees,
                    totalcbm: shipmentData.totalCbm,
                    totalweight: shipmentData.totalWeight,
                    showModal: true,
                    selectedShipment: shipmentId
                })
            })
            .catch(error => console.log(error))
    }

    removeShipmentProducts = async () => {

        try {

            const response = await this.shippingService.removeShipmentProducts(this.state.selectedShipmentProductId);

            if (response.ok) {


                const products = this.state.products.filter(p => p.orderProductId != this.state.selectedShipmentProductId);


                this.setState({

                    products: products,
                    showRemoveConfirmationBox: false
                });
            }







        } catch (error) {

        }




    }

    handleCloseModal = () => {

        this.setState({ showModal: false })
    }

    showPayment = (shipmentId, supplierId, e) => {

        e.preventDefault();

        localStorage.setItem('payment-selectedShipment', shipmentId);
        localStorage.setItem('payment-selectedSupplier', supplierId);
        this.setState({
            showPayment: true,
        });
    }

    hidePayment = () => {

        this.setState({ showPayment: false })
    }


    printShipmentProducts = (shipmentId, e) => {

        e.preventDefault();




        const response = this.shippingService.shipmentProducts(shipmentId);

        response.then(jsonData => jsonData.json())
            .then(shipmentData => {


                this.setState({
                    products: shipmentData.shipmentProducts,
                    shipmentTotal: shipmentData.total,
                    shipmentFees: shipmentData.shipmentFees,

                })




                printJS({
                    printable: 'print-data',
                    type: 'html',
                    targetStyles: ['*'],
                    css: '[../../node_modules/bootstrap/dist/css/bootstrap.min.css, ../../src/print-custom.css]',
                    maxWidth: '2000px',
                    onLoadingStart: function () {
                        $('#print-data').show();
                    },
                    onLoadingEnd: function () {

                        $('#print-data').hide();

                    },

                });


            })
            .catch(error => console.log(error))



    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    setProductBoxQuantity = async (productId, e) => {

        e.preventDefault();

        try {

            let quantity = $('#quantity-per-box-' + productId).val();

            const response = await ProductService.setProductBoxQuantity(productId, quantity);

            if (response.ok) {

                $('.error-message').html(
                    '<div class="alert alert-success shipment-alert">Mis a jour a reussi</div>'
                );
                $('.shipment-alert').delay(4000).fadeOut('slow');
            } else {

                $('.error-message').html(
                    '<div class="alert alert-danger shipment-alert">Probleme lors du mis a jour</div>'
                );
                $('.shipment-alert').delay(4000).fadeOut('slow');
            }

        } catch (error) {

            $('.error-message').html(
                '<div class="alert alert-danger shipment-alert">Probleme lors du mis a jour</div>'
            );
            $('.shipment-alert').delay(4000).fadeOut('slow');
        }

    }




    addPayment = async () => {

        try {

            let supplierId = localStorage.getItem('payment-selectedShipment');
            let countryId = $('#countryId').val();
            let desc = $('#payment-description').val();
            let amount = $('#amount').val();

            let shipmentId = localStorage.getItem('payment-selectedSupplier');

            console.log('sup: ' + this.state.selectedShipment);

            if (Utility.isEmpty(supplierId) || Utility.isEmpty(amount) || amount == 0) {

                $('.messageHolder').html(
                    '<div class="alert alert-danger message-alert">Le forunisseur et le montant doivent etre fournis</div>'
                );

                $('.message-alert').delay(3000).fadeOut('slow');

                return;
            }




            const response = await this.paymentService.addPayment(shipmentId, supplierId, desc, amount, countryId, 'shipment');

            if (response.ok) {

                const paymentData = await response.json();

                if (Utility.isEmpty(paymentData)) {

                    return;
                }



                $('#description').val("");
                $('#amount').val("");

                return;
            }


            $('.messageHolder').html(
                '<div class="alert alert-danger message-alert">Le paiement a echoué</div>'
            );

            $('.message-alert').delay(3000).fadeOut('slow');


        } catch (error) {
            console.log(error);

            $('.messageHolder').html(
                '<div class="alert alert-danger message-alert">Le paiement a echoué</div>'
            );

            $('.message-alert').delay(3000).fadeOut('slow');
        }


    }

    showCreateShipmentForm = () => {

        this.setState({
            showCreateShipment: true
        })
    }

    hideCreateShipmentForm = () => {

        this.setState({
            showCreateShipment: false
        })
    }


    createShipment = async () => {

        try {

            let containerId = $('#ccontainerId').val();
            let supplierId = $('#supplierId').val();
            let shippingDate = $('#shippingDate').val();
            let description = $('#cdescription').val();
            let eta = $('#eta').val();
            let origin = $('#originCountryId').val();
            let destinaion = $('#destinationCountryId').val();
            let branchId = $('#branchId').val();


            const response = await this.shippingService.createShipment(containerId, shippingDate, eta, destinaion,
                origin, description, supplierId, branchId);


            let shipment = await response.json();

            $('.messageHolder').html(
                '<div class="alert alert-success">Chargement Cré</div>'
            );

            let shipments = this.state.shipments;



            shipments.unshift(shipment);


            this.setState({

                shipments: shipments

            });



        } catch (error) {

            $('.messageHolder').html(
                '<div class="alert alert-danger">Creation du chargement a echoué</div>'
            );
        }

    }

    setProductWeight = async (productId, e) => {

        try {

            let weight = $('#weight-' + productId).val();

            const response = await ProductService.setProductWeight(productId, weight);

            if (response.ok) {

                $('.messageHolder').html(
                    '<div class="alert alert-success">Poids mis a jour Cré</div>'
                );

                return;
            }

            $('.messageHolder').html(
                '<div class="alert alert-danger">Probleme lors de l operation</div>'
            );

        } catch (error) {

            $('.messageHolder').html(
                '<div class="alert alert-danger">Probleme lors de l operation</div>'
            );
        }


    }

    showRemoveConfirmationForm = (productId) => {

        this.setState({

            showRemoveConfirmationBox: true,
            selectedShipmentProductId: productId
        });
    }

    hideRemoveConfirmationForm = () => {

        this.setState({

            showRemoveConfirmationBox: false
        })
    }


    updateShipmentProduct = async (e, productId, orderProductId) => {

        e.preventDefault();

        try {

            let quantity = $('#spid-' + productId).val();

            const response = await this.shippingService.updateShipmentProduct(this.state.selectedShipment, orderProductId, quantity);

            if (response.ok) {

                $('#product-row-' + productId).before(
                    '<div class="alert alert-success product-alert">Mis a jour effectué</div> '
                )
                $('.product-alert').delay(3000).fadeOut('fast');
                console.log('Ok');
            } else {

                $('#product-row-' + productId).before(
                    '<div class="alert alert-danger product-alert">Mis a jour non effectué</div> '
                )
                $('.product-alert').delay(3000).fadeOut('fast');

            }

        } catch (error) {

            $('#product-row-' + productId).before(
                '<div class="alert alert-danger product-alert">Mis a jour non effectué</div> '
            )
            $('.product-alert').delay(3000).fadeOut('fast');

            console.log(error);
        }



    }

    showShipmentConfirmation = (e, shipmentId) => {

        localStorage.setItem('confirmationShipmentId', shipmentId);

        this.setState({
            showConfirmShipment: true
        });
    }

    hideShipmentConfirmation = () => {

        this.setState({
            showConfirmShipment: false
        });
    }

    confirmShipment = async () => {

        let shipmentId = localStorage.getItem('confirmationShipmentId');

        if (Utility.isEmpty(shipmentId)) {

            alert("Des Parametres manques")

            return;
        }

        let holder = 'shipment-card-' + shipmentId;

        try {
            const response = await this.shippingService.confirShipment(shipmentId);



            if (response.ok) {



                Utility.showAlertWithId(holder, 'Chargement Confirmé', 'success', true);
                $('#' + holder).removeClass('bg-info');
                $('#confirm-btn-' + shipmentId).remove();

                this.setState({
                    showConfirmShipment: false
                });

                return;
            }
        } catch (error) {

            Utility.showAlertWithId(holder, 'Probleme lors de la confirmation', 'danger', true);
        }


    }

    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.findShipmentProducts();
        }, 1500);

        this.setState({ timeoutId: timer })
    }

    clearNameField = () => {

        $('#shipment-search-key').val('');
    }

    exportShipmentToExceL = async (shipmentId) => {

        const response = await this.shippingService.shipmentProducts(shipmentId, '', '');
        const printData = await response.json();



        const columns = [
            { label: "Image", value: "mainImage", type: "image" },
            { label: "Nom", value: "name" }, // Top level data
            { label: "Modele", value: "model" }, // Custom format
            { label: "Marque", value: "brand" },
            { label: "Numero", value: "size" },
            { label: "Couleur", value: "color" },
            { label: "CPID", value: "supplierUniqueId" },
            { label: "Prix", value: "price" },
            { label: "Quantité", value: "quantity" },
            { label: "Quantité Servie", value: "pickedQuantity" },
            { label: "CBM", value: "boxCbm" },
            { label: "Quantité Par Carton", value: "quantityInBox" },

        ];

        /*const  columnss: [
                   { label: "Nom", value: "name" }, // Top level data
                   { label: "Modele", value: "model" }, // Custom format
                   { label: "Marque", value: "brand" },
                   { label: "Numero", value: "size" },
                   { label: "Couleur", value: "color" },
                   { label: "CPID", value: "supplierUniqueId" },
                   { label: "Prix", value: "price" },
                   { label: "Quantité", value: "quantity" },
                   { label: "Quantité Servie", value: "pickedQuantity" },
                   { label: "CBM", value: "boxCbm" },
                   { label: "Quantité Par Carton", value: "quantityInBox" },

               ];*/

        //csvDownload(printData, columns, 'commande exportée');

        // Utility.jsonToExcel("Produits", printData.shipmentProducts);

        await Utility.exportJsonToExcel(

            "Produits Chargés",

            columns,

            printData.shipmentProducts,

            {

                imageWidth: 80,

                imageHeight: 80

            }

        );

    }

    render() {



        const shipmentList = this.state.shipments;
        const products = this.state.products;
        const countries = this.state.countries;
        let rowNumber = 0;
        let printRowNumber = 0;

        const style = {
            textAlignement: 'left'
        }

        let createBtn = '';
        let countrySelection = '';

        if (this.state.currentUserRole == 'SUPER-ADMIN' || this.state.currentUserRole == 'MANAGER') {

            createBtn = <button className='btn btn-primary float-right' style={{ marginTop: '', float: 'right' }} onClick={this.showCreateShipmentForm}>Nouveau Chargement</button>;
            countrySelection = <div className="form-group">
                <label className="label">Pays </label>

                <select className="form-control" id="countryId">
                    <option></option>
                    {countries.length > 0 && countries.map(country =>

                        <option key={country.countryId} value={country.countryId}>{country.name}</option>

                    )}
                </select>

            </div>;
        }

        return (
            <div className="container shipment-wrapper mt-4">

                <AuthorizationCheck accessLevel='ADMIN' userRole={this.setRole} />

                <h2 className="text-center">Liste de Chargements</h2>
                <div className="messageHolder"></div>

                <div className="container">

                    {createBtn}
                </div>

                <div className="form-wrapper">
                    <div className="row">
                        <div className="col">

                            {countrySelection}


                            <div className="form-group">
                                <input className="form-control" id="description" placeholder="Description" />
                            </div>

                            <div className="form-group">
                                <input className="form-control" id="containerId" placeholder="Numero Conteneur" />
                            </div>

                            <div className="form-group">
                                <input className="form-control" id="shipmentUniqueId" placeholder="Numero Chargement" />
                            </div>

                            <div className="form-group">
                                <button className="btn btn-primary full-width" onClick={this.shipments}>Rechercher</button>
                            </div>
                        </div>

                    </div>





                </div>

                <div id='print-data' style={{ marginBottom: '30px' }}>

                    <div className='container shipent-product-wrapper'>

                        {products != undefined && products.length > 0 && products.map(product => {


                            printRowNumber += 1;


                            return <div className="card card-default mt-2" key={product.id}>

                                <div className="card-body">

                                    <div className="row fs-6 text">
                                        <div className="col-md-6 text-start p-desc">
                                            <span class="badge bg-warning">{printRowNumber}</span>
                                            <div className='mt-2'>{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                                            <div>CPID: {product.supplierUniqueId}</div>
                                        </div>

                                        <div className="col">{product.quantity}</div>
                                        <div className="col">
                                            <div>Prix:</div>
                                            <div>{product.price}</div>

                                        </div>
                                        <div className="col">
                                            <div>Qté Par Caton:</div>
                                            <div>{product.quantityInBox}</div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        })}

                    </div>

                    <div className='container mt-3'>
                        {this.state.shipmentFees != undefined && this.state.shipmentFees.map(shipmentFee =>

                            <div className='row'>
                                <div className='col-md-2'>{shipmentFee.feeType}</div>
                                <div className='col-md-2'>
                                    <NumberFormat
                                        defaultValue={0}
                                        value={shipmentFee.amount}
                                        thousandSeparator={true}
                                        displayType="text" />

                                </div>
                            </div>

                        )}
                    </div>
                    <div className='container mt-4'>
                        <div className='row'>
                            <div className='col-md-2 text-start'>Total:</div>
                            <div className='col-md-2' style={style}>
                                <NumberFormat
                                    defaultValue={0}
                                    value={this.state.shipmentTotal}
                                    thousandSeparator={true}
                                    displayType="text" />
                            </div>

                        </div>

                    </div>

                </div>

                <Modal show={this.state.showRemoveConfirmationBox}>
                    <Modal.Header closeButton onHide={this.hideRemoveConfirmationForm}>Chargement Produit Suppression</Modal.Header>
                    <Modal.Body>



                        <div className="form-wrapper mt-4">

                            <div className="messageHolder"></div>


                            <div className="form-group">
                                <p className="label text-center">Voulez vous supprimer ce produit?</p>
                                <button className='btn btn-danger full-width' onClick={this.removeShipmentProducts}>Supprimer</button>
                            </div>


                        </div>



                    </Modal.Body>

                </Modal>


                <Modal show={this.state.confirmUnloading} size="lg">
                    <Modal.Header closeButton onHide={this.hideUnloadingForm}>Confirme Debarquation</Modal.Header>
                    <Modal.Body>



                        <div className="form-wrapper mt-4">

                            <div className="messageHolder"></div>


                            <div className="form-group">
                                <p className="label text-center">Voulez vous debarquer ce chargement?</p>
                                <button className='btn btn-danger full-width' onClick={this.setUnloaded}>Debarque</button>
                            </div>


                        </div>



                    </Modal.Body>

                </Modal>




                <Modal show={this.state.showPayment} size="lg">
                    <Modal.Header closeButton onHide={this.hidePayment}>Ajoute Payment</Modal.Header>
                    <Modal.Body>

                        <div className="container paymentHolder">

                            <div className="form-wrapper mt-4">

                                <div className="messageHolder"></div>





                                <div className="form-group">
                                    <label className="label">Pays d'origine</label>
                                    <select className="form-control" id="countryId">
                                        <option></option>
                                        {this.state.countries.length > 0 && this.state.countries.map(country =>

                                            <option value={country.countryId}>{country.name}</option>
                                        )
                                        }
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="label">Montant</label>
                                    <input className="form-control" id="amount" />
                                </div>

                                <div className="form-group">
                                    <label className="label">Description</label>
                                    <input className="form-control" id="payment-description" />
                                </div>

                                <div className="form-group">
                                    <button className="btn btn-primary full-width" onClick={this.addPayment}>Ajouter</button>
                                </div>

                            </div>

                        </div>

                    </Modal.Body>

                </Modal>



                <Modal show={this.state.showModal} fullscreen={true}>
                    <Modal.Header closeButton onHide={this.handleCloseModal}>Chargement Produits</Modal.Header>
                    <Modal.Body>


                        <span className="error-message"></span>

                        <div className='container'>
                            <div className='row'>
                                <div className='col'>Total CBM: {this.state.totalcbm}</div>
                                <div className='col'>Total POIDS: <NumberFormat
                                    defaultValue={0}
                                    value={this.state.totalweight}
                                    thousandSeparator={true}
                                    displayType="text" decimalScale={2} />
                                </div>

                                <div className='col'>

                                    Chargement Total: <NumberFormat
                                        defaultValue={0}
                                        value={this.state.shipmentTotal}
                                        thousandSeparator={true}
                                        displayType="text" />
                                </div>

                            </div>

                            <div className='row mt-2'>


                                <div className='col'>

                                    <input className='form-control' id='shipment-search-key' onKeyUp={this.searchProduct} placeholder='Entrer le nom du produit' />

                                </div>

                                <div className='col'>

                                    <input className='form-control' id='search-cpid' onFocus={this.clearNameField} onKeyUp={this.searchProduct} placeholder='CPID' />

                                </div>

                            </div>

                        </div>

                        {products != undefined && products.length > 0 && products.map(product => {


                            rowNumber += 1

                            return <div className="card card-default mt-2" key={product.id}>

                                <div className="card-body">
                                    <div className="row" id={'product-row-' + product.id}>
                                        <div className="col-md-4">
                                            <span class="badge bg-warning">{rowNumber}</span>
                                            <div className='mt-2'>{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                                            <div>CPID: {product.supplierUniqueId}</div>

                                        </div>

                                        <div className="col">
                                            <div>

                                                <label className='label'>Quantité </label>
                                                <input className='form-control'
                                                    defaultValue={product.quantity}
                                                    id={'spid-' + product.id}
                                                    onBlur={(e) => this.updateShipmentProduct(e, product.id, product.orderProductId)} />
                                            </div>
                                            <div className='text-center mt-2'>
                                                Qté Servie: {product.pickedQuantity}
                                            </div>

                                        </div>
                                        <div className="col">
                                            <label>Prix</label>
                                            <div>{product.price}</div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className='form-group'>
                                                <label className='label'>Quantité Par Carton</label>
                                                <input className='form-control' defaultValue={product.quantityInBox} id={'quantity-per-box-' + product.productId} onBlur={(e) => this.setProductBoxQuantity(product.productId, e)} />
                                            </div>
                                        </div>
                                        <div className="col remove-shipment">
                                            <div><Button onClick={() => this.showRemoveConfirmationForm(product.orderProductId)} className="btn btn-danger full-width-btn">X</Button></div>
                                            <div className='mt-3'><a style={{ fontSize: '11px' }} href={'/orderProducts?orderId=' + product.orderId + '#target-' + product.orderProductId}>{product.orderDescription}</a></div>

                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className='col-md-2 fw-bold'>

                                            <div className='form-group'>
                                                <label className='label'>Poids Par Carton</label>
                                                <input className='form-control' defaultValue={product.weight} id={'weight-' + product.productId} onBlur={(e) => this.setProductWeight(product.productId, e)} />
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </div>
                        })}

                    </Modal.Body>
                    <Modal.Footer>

                        <div className='container'>
                            <div className='row'>
                                <div className='col'>Total CBM: {this.state.totalcbm}</div>
                                <div className='col'>Total POIDS:<NumberFormat
                                    defaultValue={0}
                                    value={this.state.totalweight}
                                    thousandSeparator={true}
                                    displayType="text" decimalScale={2} /> </div>
                            </div>
                        </div>

                        <div className='container'>
                            {this.state.shipmentFees != undefined && this.state.shipmentFees.map(shipmentFee =>

                                <div className='row'>
                                    <div className='col'>{shipmentFee.feeType}</div>
                                    <div className='col'>
                                        <NumberFormat
                                            defaultValue={0}
                                            value={shipmentFee.amount}
                                            thousandSeparator={true}
                                            displayType="text" />

                                    </div>
                                </div>

                            )}
                        </div>
                        <div className='container font-weight-bold'>Total:
                            <NumberFormat
                                defaultValue={0}
                                value={this.state.shipmentTotal}
                                thousandSeparator={true}
                                displayType="text" />

                        </div>


                    </Modal.Footer>
                </Modal>


                <Modal show={this.state.showCreateShipment} size="lg">
                    <Modal.Header closeButton onHide={this.hideCreateShipmentForm}>Nouveau Chargement</Modal.Header>
                    <Modal.Body>

                        <Shipment countries={this.state.countries} createShipment={this.createShipment} branchService={this.branchService} />

                    </Modal.Body>

                </Modal>


                <Modal show={this.state.showConfirmShipment}>
                    <Modal.Header closeButton onHide={this.hideShipmentConfirmation}>Confirme Chargement</Modal.Header>
                    <Modal.Body>
                        <p className='text-center'>Voulez vous confirmer ce chargement?</p>

                        <button className='btn btn-success full-width' onClick={this.confirmShipment}>Confirme</button>

                    </Modal.Body>

                </Modal>


                <div className="card card-default mt-2 bg-primary text-white">

                    <div className="card-body">
                        <div className="row">
                            <div className="col">No Conteneur</div>

                            <div className="col">Description</div>

                            <div className="col">Origin/Destination</div>

                            <div className="col">Date</div>



                            <div className="col"></div>


                        </div>
                    </div>

                </div>

                {shipmentList.length > 0 && shipmentList.map(shipment => {


                    let rowBg = '';

                    let confirmBtn = '';

                    if (shipment.isProposal == 1) {

                        rowBg = ' bg-info';

                        confirmBtn = <div><button id={'confirm-btn-' + shipment.shipmentId} className='btn btn-primary mt-2 full-width' onClick={(e) => this.showShipmentConfirmation(e, shipment.shipmentId)}>Confirm</button></div>;

                    }

                    return <div className={"card card-default mt-2" + rowBg} id={'shipment-card-' + shipment.shipmentId} key={shipment.shipmentId}>

                        <div className="card-body">

                            <div className="row">
                                <div className="col">
                                    <div><input className="form-control mt-2" defaultValue={shipment.containerId} onBlur={(e) => this.updateShipment(shipment.shipmentId, 'containerId', e.target.value)} placeholder="Numero" id={"descriptionId-" + shipment.shipmentId} /></div>

                                </div>

                                <div className="col-md-3">
                                    <textarea className="form-control mt-2" onBlur={(e) => this.updateShipment(shipment.shipmentId, 'description', e.target.value)} placeholder="Description" id={"descriptionId-" + shipment.shipmentId}>{shipment.description}</textarea>
                                </div>

                                <div className="col">
                                    {shipment.originCountry}/{shipment.destinationCountry}
                                </div>

                                <div className="col">
                                    <div className='border'><label className='fw-bold'>Embarquement</label><div>{shipment.shippingDate}</div> </div>
                                    <div className='border mt-1'><label className='fw-bold'>Arrivée</label><div>{shipment.arrivalDate}</div></div>
                                </div>




                                <div className="col">
                                    {confirmBtn}
                                    <div><button className='btn btn-primary full-width mt-2' onClick={(e) => this.showPayment(shipment.shipmentId, shipment.supplierId, e)}>Paiement</button></div>
                                    <div><a href={"/manager/update-shipment?shipmentId=" + shipment.shipmentId + "&&countryId=" + shipment.destinationCountryId}>Edit</a></div>
                                </div>



                            </div>

                            <div className='row mt-3'>
                                <div className='col'><button className='btn btn-primary full-width mt-2' onClick={(e) => this.showShipmentProducts(shipment.shipmentId, e)}>Produits</button></div>
                                <div className='col'> {!shipment.unloaded ? <button className="btn btn-warning btn-xs full-width mt-2" onClick={() => this.selectShipment(shipment.shipmentId)}>Choisi</button> : ''}</div>
                                <div className='col'>{!shipment.unloaded ? <button className="btn btn-success btn-xs mt-2 full-width" onClick={(e) => this.confirmUnload(shipment.shipmentId, e)}>Debarque</button> : ''}</div>
                                <div className='col'><button className='btn btn-primary shipment-print-btn btn-xs mt-2 full-width' onClick={(e) => this.printShipmentProducts(shipment.shipmentId, e)}>Imprimer</button></div>
                                <div className='col'><button className='btn btn-primary shipment-print-btn btn-xs mt-2 full-width' onClick={(e) => this.exportShipmentToExceL(shipment.shipmentId, e)}>Export</button></div>

                            </div>
                            <div className='row font-weight-bold mt-2'><div className='col'>{shipment.volume != null ? 'CBM:' + shipment.volume : ''}</div></div>
                            
                            <div className='row font-weight-bold mt-2'><div className='col text-secondary fw-bold'>{shipment.shipmentUniqueNumber}</div></div>

                        </div>

                    </div>
                })}

            </div>
        )
    }

}

export default Shipments;